module.exports = __webpack_public_path__ + "static/media/pincil-register.80311117.png";